<template>
    <div class="home pa-4">
        <v-row>
            <v-col cols="12" md="4">
                <v-card v-if="profile">
                    <div>
                        <div class="text-center py-8">
                            <v-avatar
                                tile
                                size="40"
                                color="secondary"
                                class="rounded-lg"
                            >
                                <v-icon large dark>
                                    mdi-alpha-{{
                                        profile.name.charAt(0).toLowerCase()
                                    }}
                                </v-icon>
                            </v-avatar>
                            
                            <div class="mt-3">
                                <p class="font-weight-bold my-0">{{ profile.name }}</p>
                                <p class="my-0 text-caption">{{ user.email }}</p>
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="pa-6 text-caption">
                        <p class="font-weight-bold primary--text">Centro de Mapa</p>
                        <GmapMap
                            ref="map"
                            :center="{
                                lat: profile.location.latitude,
                                lng: profile.location.longitude,
                            }"
                            :zoom="profile.map_zoom"
                            :options="{
                                zoomControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: false,
                            }"
                            class="map rounded-lg overflow-hidden"
                        >
                            
                        </GmapMap>
                    </div>
                    <v-divider></v-divider>
                    <div class="text-caption pa-6">
                        <p class="font-weight-bold primary--text">Minutos sin medición</p>
                        <v-list dense>
                            <v-list-item dense>
                                <v-list-item-content>
                                    Marcar Alerta
                                </v-list-item-content>
                                <v-list-item-action>
                                    {{ profile.minutesToWarn }}
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item dense>
                                <v-list-item-content>
                                    Marcar Desconectado
                                </v-list-item-content>
                                <v-list-item-action>
                                    {{ profile.minutesToDanger }}
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">

                <v-card min-height="65vh" class="mb-5 last-measures" >
                    <v-toolbar flat v-if="project_selected">
                        <v-avatar>
                            <v-icon>
                                mdi-google-circles-extended
                            </v-icon>
                        </v-avatar>
                        {{ project_selected.name }}
                        <v-spacer></v-spacer>
                        <v-btn icon @click="openProjectsDialog" >
                            <v-icon>mdi-swap-horizontal-bold</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                        <p class="font-weight-bold primary--text text-caption">Dispositivos</p>
                        <v-toolbar outlined flat class="rounded-lg">
                            <v-avatar color="secondary" size="35" class="mr-3">
                                <v-icon dark small>mdi-resistor</v-icon>
                            </v-avatar>
                            Puntos medición

                            <v-spacer></v-spacer>
                            <span class="text-h6">{{ n_gateways }}</span>
                        </v-toolbar>

                        <v-toolbar outlined flat class="rounded-lg mt-4">
                            <v-avatar color="secondary" size="35" class="mr-3">
                                <v-icon small dark>mdi-resistor</v-icon>
                            </v-avatar>
                            Medidores

                            <v-spacer></v-spacer>
                            <span class="text-h6">{{ n_meters }}</span>
                        </v-toolbar>
                    </v-card-text>
                    <v-card outlined class="mx-4">
                        <p class="font-weight-bold primary--text text-caption px-3 py-2 ma-0">
                            Ultimas mediciones
                        </p>
                        <v-divider></v-divider>
                        <v-virtual-scroll
                            bench="10"
                            :items="lastReads"
                            :item-height="50"
                            height="20vh"
                        >
                            <template v-slot:default="{ item }">
                                <v-list-item class="text-caption">
                                    <v-list-item-content>
                                        Medidor: {{item.meter}}
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        {{ item.data.updated.toLocaleString() }}
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider></v-divider>
                            </template>
                        </v-virtual-scroll>
                    </v-card>
                </v-card>

                <v-card height="30vh">
                    <v-toolbar flat>
                        Todos los Proyectos
                        <v-spacer></v-spacer>
                        <v-btn icon @click="openProjectsDialog" >
                            <v-icon>mdi-cog</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-virtual-scroll
                        bench="10"
                        :items="projects"
                        :item-height="60"
                        height="20vh"
                    >
                        <template v-slot:default="{ item }">
                            <v-list-item class="text-caption">
                                <v-list-item-icon>
                                    <v-icon>
                                        mdi-google-circles-extended
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    {{item.name}}
                                </v-list-item-content>
                                <v-list-item-action v-if="item.id === project_selected.id">
                                    <v-chip small color="accent">
                                        Actual
                                    </v-chip>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-virtual-scroll>
                </v-card>
            </v-col>
        </v-row>

        <Projects ref="ProjectsDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Projects from '../components/projects.vue'
export default {
    name: 'Home',
    components: { Projects },
    computed: {
        ...mapState({
            n_meters: (state) => state.meters.list.length,
            lastReads: (state) => state.meters.lastReadings || [],
            n_gateways: (state) => state.gateways.list.length,
            profile: (state) => state.account.profile,
            user: state => state.user.profile,
            project_selected: (state) => state.projects.selected,
            projects: (state) => state.projects.list,
        }),
    },
    methods: {
        ...mapActions({
            updatedView: 'user/updatedView',
        }),
        openProjectsDialog(){
            this.$refs.ProjectsDialog.openDialog()
        }
    },
    mounted() {
        this.updatedView('Home')
    },
}
</script>

<style scoped>
.map{
    height: 305px;
    width: 100%;
}
</style>